import React from 'react';

export default ({article}) => {
  return (
    <div className="not-found">
      <h1>404 Not Found</h1>
    </div>
  );
}